import { dispatchUserInteractionEvent } from './dispatchUserInteractionEvent';

export function dispatchAccountDiscoveryFoundSAMLEvent() {
  return dispatchUserInteractionEvent({
    event_action: 'open',
    option_selected: 'account_discovery_found_saml',
    interaction_name: 'account_discovery_found_saml',
    interaction_goal:
      'Find discovered account to see if we should redirect to SAML provider',
  });
}

export function dispatchAccountDiscoveryNoSAMLEvent() {
  return dispatchUserInteractionEvent({
    event_action: 'open',
    option_selected: 'account_discovery_no_saml',
    interaction_name: 'account_discovery_no_saml',
    interaction_goal:
      'Find discovered account to see if we should redirect to SAML provider',
  });
}

export function dispatchAccountDiscoveryNoAccountEvent() {
  return dispatchUserInteractionEvent({
    event_action: 'open',
    option_selected: 'account_discovery_no_account',
    interaction_name: 'account_discovery_no_account',
    interaction_goal:
      'Find discovered account to see if we should redirect to SAML provider',
  });
}
